import { useMutation } from "@tanstack/react-query";
import type { UseMutationOptions } from "@tanstack/react-query";
import { customFetch } from "./custom-fetch";
import type { ErrorType } from "./custom-fetch";
import type { InvoiceDetail } from "./generated/api.schemas";

export interface MarkDepositReceivedBody {
  amount: number;
  paymentMethod?: string | null;
  paymentDate?: string;
  notes?: string | null;
}

export const markDepositReceived = async (
  invoiceId: number,
  data: MarkDepositReceivedBody
): Promise<InvoiceDetail> =>
  customFetch<InvoiceDetail>(`/api/invoices/${invoiceId}/mark-deposit-received`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

export const useMarkDepositReceived = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: UseMutationOptions<
    InvoiceDetail,
    TError,
    { invoiceId: number; data: MarkDepositReceivedBody },
    TContext
  >
) => {
  return useMutation<
    InvoiceDetail,
    TError,
    { invoiceId: number; data: MarkDepositReceivedBody },
    TContext
  >({
    mutationFn: ({ invoiceId, data }) => markDepositReceived(invoiceId, data),
    ...options,
  });
};
